import { useEffect } from 'react';

const useHideHubSpotChat = (shouldHideChat: boolean) => {
    useEffect(() => {
        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
            if (shouldHideChat) {
                window.HubSpotConversations.widget.remove();
            } else {
                window.HubSpotConversations.widget.load();
            }
        }
    }, [shouldHideChat]);
};

export default useHideHubSpotChat;
